(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $cd5a47cf8ef6d766$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}



function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.initialState = initialState;
        this.score = 0;
        this.status = Game.gameStatus.idle;
        this.state = initialState.map(function(row) {
            return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        });
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "getRandomCell",
            value: function getRandomCell() {
                var emptyCells = [];
                for(var row = 0; row < 4; row++){
                    for(var col = 0; col < 4; col++)if (this.state[row][col] === 0) emptyCells.push([
                        row,
                        col
                    ]);
                }
                if (emptyCells.length > 0) {
                    var randomIndex = Math.floor(Math.random() * emptyCells.length);
                    var _emptyCells_randomIndex = (0, $efec029548ccee7f$export$71511d61b312f219)(emptyCells[randomIndex], 2), randomRow = _emptyCells_randomIndex[0], randomCol = _emptyCells_randomIndex[1];
                    this.state[randomRow][randomCol] = Math.random() < 0.9 ? 2 : 4;
                }
            }
        },
        {
            key: "checkStatus",
            value: function checkStatus() {
                var hasEmptyCells = false;
                var canMove = false;
                for(var row = 0; row < 4; row++)for(var col = 0; col < 4; col++){
                    var cellValue = this.state[row][col];
                    if (cellValue === 2048) {
                        if (this.status !== Game.gameStatus.win) this.status = Game.gameStatus.win;
                    }
                    if (cellValue === 0) hasEmptyCells = true;
                    if (row < 3 && cellValue === this.state[row + 1][col] || col < 3 && cellValue === this.state[row][col + 1]) canMove = true;
                }
                if (!hasEmptyCells && !canMove) this.status = Game.gameStatus.lose;
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this, _loop = function(row) {
                    var newRow = _this.state[row].filter(function(val) {
                        return val !== 0;
                    });
                    var mergedRow = [];
                    for(var i = 0; i < newRow.length; i++)if (newRow[i] === newRow[i + 1]) {
                        mergedRow.push(newRow[i] * 2);
                        _this.score += newRow[i] * 2;
                        i++;
                    } else mergedRow.push(newRow[i]);
                    _this.state[row] = mergedRow.concat(Array(4 - mergedRow.length).fill(0));
                };
                var previousState = this.state.map(function(row) {
                    return row.slice();
                });
                for(var row = 0; row < 4; row++)_loop(row);
                this.checkForChanges(previousState);
                this.checkStatus();
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var _this = this, _loop = function(row) {
                    var newRow = _this.state[row].filter(function(val) {
                        return val !== 0;
                    }).reverse();
                    var mergedRow = [];
                    for(var i = 0; i < newRow.length; i++)if (newRow[i] === newRow[i + 1]) {
                        mergedRow.push(newRow[i] * 2);
                        _this.score += newRow[i] * 2;
                        i++;
                    } else mergedRow.push(newRow[i]);
                    _this.state[row] = Array(4 - mergedRow.length).fill(0).concat(mergedRow.reverse());
                };
                var previousState = this.state.map(function(row) {
                    return row.slice();
                });
                for(var row = 0; row < 4; row++)_loop(row);
                this.checkForChanges(previousState);
                this.checkStatus();
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                this.state = this.transpose(this.state);
                this.moveLeft();
                this.state = this.transpose(this.state);
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                this.state = this.transpose(this.state);
                this.moveRight();
                this.state = this.transpose(this.state);
            }
        },
        {
            key: "transpose",
            value: function transpose(state) {
                var result = [];
                for(var col = 0; col < 4; col++){
                    result[col] = [];
                    for(var row = 0; row < 4; row++)result[col].push(state[row][col]);
                }
                return result;
            }
        },
        {
            key: "checkForChanges",
            value: function checkForChanges(previousState) {
                if (this.state.toString() !== previousState.toString()) {
                    this.getRandomCell();
                    this.status = Game.gameStatus.playing;
                }
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.state;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "start",
            value: function start() {
                this.status = Game.gameStatus.playing;
                this.getRandomCell();
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.state = this.initialState.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
                this.score = 0;
                this.status = Game.gameStatus.idle;
            }
        }
    ]);
    return Game;
}();
(0, $cd5a47cf8ef6d766$export$71511d61b312f219)($3d28d7f1aac198f5$var$Game, "gameStatus", {
    idle: "idle",
    playing: "playing",
    win: "win",
    lose: "lose"
});
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$startButton = document.querySelector(".start");
var $197cd56b15c33885$var$gameScore = document.querySelector(".game-score");
var $197cd56b15c33885$var$gameField = document.querySelector(".game-field");
var $197cd56b15c33885$var$messageLose = document.querySelector(".message-lose");
var $197cd56b15c33885$var$messageWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$messageStart = document.querySelector(".message-start");
$197cd56b15c33885$var$startButton.addEventListener("click", function() {
    if ($197cd56b15c33885$var$startButton.classList.contains("start")) {
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$startButton.classList.remove("start");
        $197cd56b15c33885$var$startButton.classList.add("restart");
        $197cd56b15c33885$var$startButton.textContent = "Restart";
        $197cd56b15c33885$var$messageStart.classList.add("hidden");
        $197cd56b15c33885$var$messageLose.classList.add("hidden");
        $197cd56b15c33885$var$messageWin.classList.add("hidden");
    } else if ($197cd56b15c33885$var$startButton.classList.contains("restart")) {
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$startButton.classList.remove("restart");
        $197cd56b15c33885$var$startButton.classList.add("start");
        $197cd56b15c33885$var$startButton.textContent = "Start";
        $197cd56b15c33885$var$messageStart.classList.remove("hidden");
        $197cd56b15c33885$var$messageLose.classList.add("hidden");
        $197cd56b15c33885$var$messageWin.classList.add("hidden");
    }
    $197cd56b15c33885$var$updateGameField();
    $197cd56b15c33885$var$setScore();
});
document.addEventListener("keyup", function(e) {
    var moves = {
        ArrowRight: $197cd56b15c33885$var$game.moveRight,
        ArrowLeft: $197cd56b15c33885$var$game.moveLeft,
        ArrowUp: $197cd56b15c33885$var$game.moveUp,
        ArrowDown: $197cd56b15c33885$var$game.moveDown
    };
    if (moves[e.key]) moves[e.key].call($197cd56b15c33885$var$game);
    $197cd56b15c33885$var$updateGameField();
    $197cd56b15c33885$var$setScore();
    $197cd56b15c33885$var$setMessage();
});
function $197cd56b15c33885$var$updateGameField() {
    $197cd56b15c33885$var$gameField.innerHTML = "";
    var currentState = $197cd56b15c33885$var$game.getState();
    for(var row = 0; row < 4; row++){
        var tr = document.createElement("tr");
        for(var col = 0; col < 4; col++){
            var td = document.createElement("td");
            var value = currentState[row][col];
            td.textContent = value !== 0 ? value : "";
            td.classList.add("field-cell");
            if (value !== 0) td.classList.add("field-cell--".concat(value));
            tr.appendChild(td);
        }
        $197cd56b15c33885$var$gameField.appendChild(tr);
    }
}
function $197cd56b15c33885$var$setScore() {
    if ($197cd56b15c33885$var$gameScore) $197cd56b15c33885$var$gameScore.textContent = $197cd56b15c33885$var$game.getScore();
}
function $197cd56b15c33885$var$setMessage() {
    var currStatus = $197cd56b15c33885$var$game.getStatus();
    $197cd56b15c33885$var$messageWin.classList.toggle("hidden", currStatus !== $3d28d7f1aac198f5$exports.gameStatus.win);
    $197cd56b15c33885$var$messageLose.classList.toggle("hidden", currStatus !== $3d28d7f1aac198f5$exports.gameStatus.lose);
}
$197cd56b15c33885$var$updateGameField();
$197cd56b15c33885$var$setMessage();
$197cd56b15c33885$var$setScore();

})();
//# sourceMappingURL=index.ebcd1b2a.js.map
